// vehicleFilterSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { VehicleType } from "../../types";

interface VehicleFilterState {
  pickupLocation: {
    lat: number;
    lng: number;
  };
  displayVehicles: VehicleType[];
  isModalOpen: boolean;
  brandFilter: string | null;
  vehicleToEdit: Partial<VehicleType> | null;
  isChangePlan: ChangePlan | null;
}

interface ChangePlan {
  carId: string;
  planId: string;
}

const initialState: VehicleFilterState = {
  pickupLocation: {
    lat: 0,
    lng: 0,
  },
  displayVehicles: [],
  isModalOpen: false,
  brandFilter: null,
  vehicleToEdit: null,
  isChangePlan: null,
};

const vehicleFilterSlice = createSlice({
  name: "vehicleFilter",
  initialState,
  reducers: {
    setPickupLocationState: (
      state,
      action: PayloadAction<{
        lat: number;
        lng: number;
      }>
    ) => {
      state.pickupLocation = action.payload;
    },
    clearPickupLocationState: (state) => {
      state.pickupLocation = {
        lat: 0,
        lng: 0,
      };
    },
    setDisplayVehicles: (state, action: PayloadAction<VehicleType[]>) => {
      state.displayVehicles = action.payload;
    },
    updateDisplayVehicles: (
      state,
      action: PayloadAction<Partial<VehicleType>>
    ) => {
      state.displayVehicles = state.displayVehicles.map((vehicle) =>
        vehicle.id === action.payload.id
          ? { ...vehicle, ...action.payload }
          : vehicle
      );
    },
    setImageModalState: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload;
    },
    setBrandFilter: (state, action: PayloadAction<string | null>) => {
      state.brandFilter = action.payload;
    },
    setVehicleToEdit: (state, action: PayloadAction<Partial<VehicleType>>) => {
      state.vehicleToEdit = {
        ...state.vehicleToEdit,
        ...action.payload,
      };
    },
    clearVehicleToEdit: (state) => {
      state.vehicleToEdit = null;
    },
    setIsChangePlan: (state, action: PayloadAction<ChangePlan | null>) => {
      state.isChangePlan = action.payload;
    },
  },
});

export const {
  setPickupLocationState,
  clearPickupLocationState,
  setDisplayVehicles,
  updateDisplayVehicles,
  setImageModalState,
  setBrandFilter,
  setVehicleToEdit,
  clearVehicleToEdit,
  setIsChangePlan,
} = vehicleFilterSlice.actions;
export default vehicleFilterSlice.reducer;
